









import Vue from 'vue';
import moment from 'moment';
import { formatDateTime } from '.';

interface Data {
  timerId: number|undefined,
  humanized: string|null,
}

export default Vue.extend({
  props: {
    time: String,
  },
  data(): Data {
    return {
      timerId: undefined,
      humanized: null,
    };
  },
  computed: {
    fullTime(): string {
      return formatDateTime(this.time);
    },
  },
  methods: {
    update() {
      this.humanized = moment(this.time).fromNow();
    },
  },
  created() {
    this.update();
    this.timerId = setInterval(this.update, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timerId);
  },
});
